// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6d225330","453":"bffc2589","455":"3af66fa4","977":"3521cace"}[chunkId] + ".chunk.js";
};